import { Box } from '@mui/material'
import Header from 'components/Header'
import ListNavigation from 'components/ListNavigation'
import React from 'react'
import { useParams } from 'react-router-dom'

const SalesOrder = () => {
  const { company } = useParams()
  const salesOrderOptions = [
    { label: 'Sales Order Picking', path: '/sales-order/sales-order-picking' },
    { label: 'Update Order Cache', path: '/sales-order/update-order-cache' }
  ]
  return (
    <Box>
      <Header />
      <ListNavigation elements={salesOrderOptions} company={company!} />
    </Box>
  )
}

export default SalesOrder
